import {
  CLEAR_THREAD
} from '@/store/mutation-types'
import { firebaseAction } from 'vuexfire'
import l from '@/vendor/logger'
import { db } from '@/store'

const state = {
  thread: []
}

const getters = {
  reversedThread (state) {
    return [...state.thread].reverse()
  }
}

const mutations = {
  [CLEAR_THREAD] (state) {
    state.thread = []
  }
}

const actions = {
  bindChat: firebaseAction(({ bindFirebaseRef, rootState }) => {
    bindFirebaseRef('thread', db.ref(`chat/${rootState.rid}`))
  }),

  unbindChat: firebaseAction(({ unbindFirebaseRef, rootState, commit }) => {
    unbindFirebaseRef('thread', db.ref(`chat/${rootState.rid}`))
    db.ref(`chat/${rootState.rid}`).off()
    commit(CLEAR_THREAD)
  }),

  async sendMessage ({ commit, state, rootState }, { uid, nickname, message }) {
    l.d('chat/sendMessage', uid, nickname, message, rootState.rid)
    if (!db.ref(`chat/${rootState.rid}`)) { return }
    try {
      await db.ref(`chat/${rootState.rid}`)
        .push()
        .set({
          uid,
          nickname,
          message,
          level: 8
        })
    } catch (err) {
      l.e(`chat/sendMessage`, err)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
